import { render, staticRenderFns } from "./customSerchInputItem.vue?vue&type=template&id=bda3d474&scoped=true"
import script from "./customSerchInputItem.vue?vue&type=script&lang=js"
export * from "./customSerchInputItem.vue?vue&type=script&lang=js"
import style0 from "./customSerchInputItem.vue?vue&type=style&index=0&id=bda3d474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda3d474",
  null
  
)

export default component.exports